import { Component, OnInit } from '@angular/core';
import { DataStoreService } from '../../core/services/data-store/data-store.service';

@Component({
  selector: 'baf-data-view-header',
  templateUrl: './data-view-header.component.html',
  styleUrls: ['./data-view-header.component.css']
})
export class DataViewHeaderComponent implements OnInit {
  constructor(private storeService: DataStoreService) {}

  get caption(): string {
    return 'Zawiadomienia ' + this.storeService.currentViewName;
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/data-view-header/data-view-header.component.ts